import styled from "styled-components";

interface ContentProps {
  $isCollapsed?: boolean;
}

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  /* scrollbar 제거 */
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Content = styled.div<ContentProps>`
  display: grid;
  grid-template-columns: ${(props) => (props.$isCollapsed ? "122px" : "256px")} 1fr; /* 240px = sidebar width */
  height: 100vh; /* 화면 전체 높이 고정 */
  transition: grid-template-columns 0.3s ease;
`;

export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 80px;
  width: 100%;
  margin: 0 auto;
  overflow-y: auto;
  max-width: 1256px;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const EmptySpace = styled.div`
  width: 100%;
  height: 346px;
`;

export const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
`;

export const RightContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 14px;
`;

export const Title = styled.div`
  height: 72px;
  margin: 0;
  padding: 16px 0;
  color: #0d141c;
  font-size: 28px;
  font-weight: 700;
  text-align: left;
`;

export const SubTitle = styled.div`
  color: black;
  font-size: 24px;
  font-weight: 600;
`;

export const VideoStyle = styled.video`
  width: 100%;
  height: auto;
  border-radius: 12px;
`;

export const VideoInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 24px;
`;

export const VideoInfoRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  font-size: 12px;
  font-weight: 400;
  line-height: 21px;
`;

export const VideoTitle = styled.div`
  color: #0d141c;
  font-size: 24px;
  font-weight: 500;
  padding: 6px 0;
`;

export const SubDownloadButton = styled.a`
  background-color: #30b0c7;
  color: white;
  padding: 6px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  width: 115px;
  font-weight: 600;
  font-size: 12px;
  text-align: center;
  line-height: 24px;

  &:hover {
  }
`;

export const VideoInfo = styled.div`
  color: black;
  font-size: 12px;
  font-weight: 300;
  word-wrap: break-word;
  line-height: 21px;
`;

export const FileButtonStyle = styled.button`
  background-color: #30b0c7;
  color: white;
  padding: 6px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
`;

export const FileInputStyle = styled.input`
  display: none;
`;

export const InputStyle = styled.input`
  width: 100%;
  height: 40px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 0 12px;
`;

export const BackgroundContainer = styled(MainContainer)`
  position: relative;
  width: 100%;
  min-height: 100vh;
`;

export const Logo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  cursor: pointer;
`;